/**
 * 能力项分值输入
 * @author 3173
 * @date 2020-07-19
 */

import React from 'react';
import PropTypes, { instanceOf } from 'prop-types';
import { connect } from 'dva';
import { Divider } from 'antd'
import { framework_tool, component_tool, utils_tool } from '@/tool'
let { WizContainer } = framework_tool;
let { WizCol, WizInputNumber, WizButton, WizList, WizTable } = component_tool;
import cloneDeep from 'lodash/cloneDeep'


class ScoreEditList extends WizContainer {

  componentName = 'scoreEditList';

  static propTypes = {
    value: PropTypes.array,
    onChange: PropTypes.func
  };

  constructor(props) {
    super(props);
    let neoValue = cloneDeep(props.value);
    if(neoValue && neoValue instanceof Array){
      neoValue.forEach((e)=>{
        if (!e.key && e.id) {
          e.key = e.id;
        } else if(!e.key) {
          e.key = e.name + new Date().getTime()
        }
        if (!e.abilityItemDetailId) {
          e.abilityItemDetailId = e.itemDetailId
        }
      })
    }
    this.state = {
      value: neoValue,   //[{'key':1,'id':1,'name':'能力项1','target':100,'state':1,'score':0}]
      visible: false,
    };
  }

  _componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({ value: cloneDeep(nextProps.value) , time:new Date().getTime()});
    }
  }

  _componentDidMount(){
    // if (this.props.value) {
    //   let neoValue = Object.assign([],this.props.value);
    //   neoValue.forEach((e)=>{
    //       if(!e.score && e.score!==0){
    //         e.score = 0;
    //       }
    //   })
    //   this.setValue(neoValue)
    // }
  }


  /** 改变行属性 */
  scoreChange(record,score){
    let {value} = this.state;
    let neoValue = Object.assign([],value);
    neoValue.forEach((value, index) => {
       if(value.key === record.key){
          value.score = score;
       }
    });
    this.setValue(neoValue);
  }

  /**更新state并返回值给form */
  setValue(value){
    const { onChange } = this.props;
    this.setState(
      {value:value, visible:new Date().getTime()},
      ()=>{
        if (onChange) {
          onChange(value);
        }
      }
    )
  }


  /**
   * 渲染列表
   */
  _renderList() {
    const { simplify , ...otherProps } = this.props;

    let columns = [];

    if(simplify){
      columns = [
        {
          title: '能力项名称',
          dataIndex: 'name',
          key: 'name',
          width: 80
        },
        {
          title: '目标能力值',
          dataIndex: 'score',
          key: 'score',
          width: 80,
          render: (text, record) => (
            <WizInputNumber min={0} max={9999} value={record.score} precision={2} onChange={(value)=>{ this.scoreChange(record,value) }}/>
          ),
         
        }
      ]
    }else{
      columns = [
        {
          title: '能力项名称',
          dataIndex: 'name',
          key: 'name',
          width: 80
        },
        {
          title: '目标能力值',
          dataIndex: 'target',
          key: 'target',
          width: 50
        },
        {
          title: '是否展示',
          dataIndex: 'exhibition',
          key: 'exhibition',
          dict: [
            { code: 1, codeName: '是' },
            { code: 0, codeName: '否' }
          ],
          width: 50,
          render: (text, record) => (
            <>{record.exhibition == 1 ? "是":"否"}</>
          ),
         
        },
        {
          title: '实际能力值',
          dataIndex: 'score',
          key: 'score',
          width: 50,
          render: (text, record) => (
            <WizInputNumber min={0} max={(record.target&&record.target!=-1)||record.target==0?record.target:0} value={record.score} precision={2} onChange={(value)=>{ this.scoreChange(record,value) }}/>
          ),
         
        }
      ]
    }
    return (
      <WizTable pagination={false} columns={columns} dataSource={this.state.value} />
    )

  }

  _render() {
    return (
        this._renderList()
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  }
};

export default connect(mapStateToProps)(ScoreEditList);
